var ContactModalController = function ($scope, $state, $modalInstance) {
    /**
     *  Close modal window
     **/
    $scope.cancel = function () {
        $modalInstance.dismiss("cancel");
    };
};

ContactModalController.$inject = ["$scope", "$state", "$modalInstance"];
export default ContactModalController;
